import React from "react";
import { useNavigate } from "react-router-dom";

import TwoFactorSetupFlow from "@/features/security/TwoFactorSetupFlow.jsx";

export default function TwoFactorSms() {
  const nav = useNavigate();

  return (
    <TwoFactorSetupFlow
      defaultMethod="sms"
      role="patient"
      onExit={() => nav("/settings/patient/login-security/two-factor")}
      onDone={() => nav("/settings/patient/login-security/two-factor")}
    />
  );
}
